import { useSuspenseQuery } from "@tanstack/react-query";
import api from "apis";
import { FindRegularMembersParams } from "apis/data-contracts";

const useRegularMembersQuery = (query: FindRegularMembersParams) => {
  return useSuspenseQuery({
    queryKey: api.user.findRegularMembersKey(query),
    queryFn: () => api.user.findRegularMembers(query),
    select: (res) => res.data.result,
  });
};

export default useRegularMembersQuery;
